import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=27fb5099&"
import script from "./textarea.vue?vue&type=script&lang=js&"
export * from "./textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27fb5099')) {
      api.createRecord('27fb5099', component.options)
    } else {
      api.reload('27fb5099', component.options)
    }
    module.hot.accept("./textarea.vue?vue&type=template&id=27fb5099&", function () {
      api.rerender('27fb5099', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/form-templates/textarea.vue"
export default component.exports